module.exports = __webpack_public_path__ + "static/media/progate.60c48226.png";